// import Case from '../../../api/cases/case';
import Case from '../../../api/cases/case';
import fileDownload from "js-file-download";

const cases = new Case();

const caseModule = {
    namespaced: true,
    state: {
        item: null,
        items: [],
        total: 0,
        lookups: null,
        auditor: null,
        load: false,
    },
    getters: {
        items(state) {
            return state.items;
        },
        item(state) {
            return state.item;
        },
        load(state) {
            return state.load;
        },
        total(state) {
            return state.total;
        },
        // status(state) {
        //     return state.item.removed;
        // },
        lookups(state) {
            return state.lookups;
        },
        // auditor(state) {
        //     return state.auditor;
        // },
    },
    mutations: {
        SET_ITEMS: (state, users) => {
            state.items = users;
        },
        SET_TOTAL_ITEMS: (state, total) => {
            state.total = total;
        },
        SET_ITEMS_LOAD: (state, load) => {
            state.load = load;
        },
        SET_ITEM: (state, user) => {
            state.item = user;
        },
        SET_LOOKUPS(state, lookups) {
            state.lookups = lookups;
        },
        UPDATE_CASES_AUDITOR(state, auditor) {
            state.auditor = auditor;
        }
    },
    actions: {
        cases({ commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_ITEMS_LOAD', true);
                cases.list(payload.query)
                    .then(response => {
                        console.log("gettter", response.data);
                        commit('SET_ITEMS', response.data);
                        commit('SET_TOTAL_ITEMS', response.meta.count);
                        commit('SET_LOOKUPS', response.meta.lookup);
                        commit('SET_ITEMS_LOAD', false);
                        resolve(response);
                    })
            });
        },
        put({ commit }, payload) {
            commit('app/UPDATE_LOAD', true, { root: true });
            return new Promise((resolve, reject) => {
                cases.put(payload.id, payload.query).then(response => {
                    commit('app/UPDATE_LOAD', false, { root: true });
                    resolve();
                }).catch(error => {
                    commit('app/UPDATE_LOAD', false, { root: true });
                    reject(error);
                });
            });
        },
        changeStatus({ commit }, payload) {
            commit('app/UPDATE_LOAD', true, { root: true });
            return new Promise((resolve, reject) => {
                cases.changeStatus(payload).then(response => {
                    commit('app/UPDATE_LOAD', false, { root: true });
                    resolve();
                }).catch(error => {
                    commit('app/UPDATE_LOAD', false, { root: true });
                    reject(error);
                });
            });
        },
        get({ commit }, id) {
            return new Promise((resolve, reject) => {
                commit('SET_ITEMS_LOAD', true);
                cases.get(id).then(response => {
                    commit('SET_ITEM', response.data);
                    commit('app/UPDATE_PAGE_DETAILS', response.data, { root: true });
                    commit('SET_ITEMS_LOAD', false);
                    resolve(response);
                })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        remove({ commit }, id) {
            return new Promise((resolve, reject) => {
                cases.remove(id)
                    .then(response => {
                        resolve();
                    })
            });
        },
        restore({ commit }, id) {
            return new Promise((resolve, reject) => {
                cases.restore(id)
                    .then(response => {
                        resolve();
                    })
            });
        },

        export({ commit }, payload) {
            const { onDownloadProgress, cancelToken, ...queryData } = payload;

            return new Promise((resolve, reject) => {
                cases.export(queryData, onDownloadProgress, cancelToken)
                    .then(response => {
                        fileDownload(response, 'cases.csv');
                        resolve();
                    })
            });
        },

        exportMrm({ commit }, payload) {
            const { onDownloadProgress, cancelToken, ...queryData } = payload;

            return new Promise((resolve, reject) => {
                cases.exportMrm(queryData, onDownloadProgress, cancelToken)
                    .then(response => {
                        fileDownload(response, 'mrm_cases.csv');
                        resolve();
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        exportApprovalTracking({ commit }, payload) {
            const { onDownloadProgress, cancelToken, ...queryData } = payload;

            return new Promise((resolve, reject) => {
                cases.exportApprovalTracking(queryData, onDownloadProgress, cancelToken)
                    .then(response => {
                        fileDownload(response, 'approval_tracking.csv');
                        resolve();
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        exportInvoiceReport({ commit }, payload) {
            const { onDownloadProgress, cancelToken, ...queryData } = payload;

            return new Promise((resolve, reject) => {
                cases.exportInvoiceReport(queryData, onDownloadProgress, cancelToken)
                    .then(response => {
                        fileDownload(response, 'invoice_report.csv');
                        resolve();
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        exportCollectedReport({ commit }, payload) {
            const { onDownloadProgress, cancelToken, ...queryData } = payload;

            return new Promise((resolve, reject) => {
                cases.exportCollectedReport(queryData, onDownloadProgress, cancelToken)
                    .then(response => {
                        fileDownload(response, 'CollectedReport.csv');
                        resolve();
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        exportTrendingReport({ commit }, payload) {
            const { onDownloadProgress, cancelToken, ...queryData } = payload;

            return new Promise((resolve, reject) => {
                cases.exportTrendingReport(queryData, onDownloadProgress, cancelToken)
                    .then(response => {
                        fileDownload(response, 'TrendingReport.csv');
                        resolve();
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        exportDischargeSummary({ commit }, payload) {
            const { onDownloadProgress, cancelToken, ...queryData } = payload;

            return new Promise((resolve, reject) => {
                cases.exportDischargeSummary(queryData, onDownloadProgress, cancelToken)
                    .then(response => {
                        fileDownload(response, 'discharge_summary.xlsx');
                        resolve();
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        exportEmrReport({ commit }, payload) {
            const { onDownloadProgress, cancelToken, ...queryData } = payload;

            return new Promise((resolve, reject) => {
                cases.exportEmrReport(queryData, onDownloadProgress, cancelToken)
                    .then(response => {
                        fileDownload(response, 'emr_report.xlsx');
                        resolve();
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        removeDepartmentLink({ commit }, payload) {
            const { onDownloadProgress, ...queryData } = payload;

            return new Promise((resolve, reject) => {
                cases.removeDepartmentLink(payload)
                    .then(response => {
                        resolve(response);
                    }).catch(error => {
                        reject(error)
                    });
            });
        },
        assignAuditor({ commit }, payload) {
            return new Promise((resolve, reject) => {
                cases.assignAuditor(payload)
                    .then(response => {
                        resolve(response);
                    }).catch(error => {
                        reject(error)
                    });
            });
        },
    },

};

export default caseModule;